import { Injectable } from "@angular/core";
import { CanActivateChild, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { of } from "rxjs";
import { AppOAuthStore } from "../models/AppOAuthSotarge";
import { verticalMenuItems } from "../theme/components/menu/menu";
import { Menu } from "../theme/components/menu/menu.model";
import { httpConnect } from "./httpConnect.service";

@Injectable()
export class AuthLogInService implements CanActivateChild {
    public menuss: Array<Menu> = verticalMenuItems;
    constructor( private router : Router , private myStorage: AppOAuthStore ) { }
    // canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    //     throw new Error('Method not implemented.');
    // }
    canActivateChild( route : ActivatedRouteSnapshot, state : RouterStateSnapshot ) : Promise<boolean> {
        console.log('resolviendo..')
        return new Promise((resolve) => {
            const id_usuario:number = +this.myStorage.getItem("id_usuario") ||0;
            if(id_usuario > 0){
             // this.router.navigate(['/dashboard']);
            } 
            resolve(true);
        });
    }
}